import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Input, Button, Row, Col, Form, DatePicker, Select } from "antd";
import moment, { now } from "moment";
import * as Yup from "yup";
import { useFormik } from "formik";

import { DataTable } from "./components";
import PageTitle from "../../_components/PageTitle";
import dashboardActions from "../../_actions/dashboard.actions";

const { RangePicker } = DatePicker;
const { Option } = Select;
const Dashboard = () => {
  const dispatch = useDispatch();
  const { filterTerminals, getTerminals } = dashboardActions;
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [page, setPage] = useState(1);

  const handleReset = (page) => {
    setStartDate();
    setEndDate();
    resetForm();
    setPage(1);
    dispatch(getTerminals(1));
  };

  const handleRangeChange = (dates) => {
    setFieldValue("startDate", `${dates[0].format("YYYY-MM-DD")} 00:00:00`);
    setFieldValue("endDate", `${dates[1].format("YYYY-MM-DD")} 23:59:59`);
  };

  const getInitialFilters = () => {
    return {};
  };

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setFieldValue,
    resetForm,
  } = useFormik({
    initialValues: getInitialFilters(),
    validationSchema: Yup.object({
      status: Yup.string(),
      caseId: Yup.string(),
      startDate: Yup.string(),
      endDate: Yup.string(),
    }),
    onSubmit() {
      fetchData(1);
    },
  });

  const fetchData = (page) => {
    const filters = {
      pageNumber: page,
      ...values,
    };
    setPage(page);

    if (!values.status) delete values.status;
    if (!values.caseId) delete values.caseId;
    if (!values.startDate) delete values.startDate;
    if (!values.endDate) delete values.endDate;

    dispatch(filterTerminals(10, filters));
  };

  return (
    <div>
      <PageTitle>Dashboard</PageTitle>
      <div className="filter__container">
        <Row gutter={[16, 16]} type="flex" justify="space-between">
          <Col
            sm={{ span: 24 }}
            lg={{ span: 24 }}
            xl={{ span: 24 }}
            xxl={{ span: 24 }}
          >
            <Row gutter={[16, 16]} type="flex" justify="start">
              <Col sm={12} md={12} lg={12} xl={8} xxl={8}>
                <Form.Item>
                  <label>Case ID:</label>
                  <Input
                    placeholder="Case ID"
                    name="caseId"
                    allowClear={true}
                    onChange={(e) => setFieldValue("caseId", e.target.value)}
                    value={values.caseId}
                  />
                </Form.Item>
              </Col>
              <Col sm={12} md={12} lg={12} xl={8} xxl={8}>
                <Form.Item>
                  <label>Status:</label>
                  <Select
                    showSearch
                    style={{ width: "100%" }}
                    allowClear={true}
                    placeholder="Select a status"
                    optionFilterProp="children"
                    onChange={(value) => setFieldValue("status", value)}
                    value={values.status}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    <Option value="SUCCESS">Success</Option>
                    <Option value="PENDING">Pending</Option>
                    <Option value="FAILED">Failed</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col sm={24} md={24} lg={12} xl={8} xxl={8}>
                <Form.Item>
                  <label>Date Range:</label>
                  <RangePicker
                    style={{ width: "100%" }}
                    allowClear={false}
                    value={
                      values.startDate && values.endDate
                        ? [moment(values.startDate), moment(values.endDate)]
                        : []
                    }
                    onChange={handleRangeChange}
                    placeholder={["Start Date", "End Date"]}
                    format="YYYY-MM-DD"
                    separator="-"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col
            sm={{ span: 24 }}
            lg={{ span: 24 }}
            xl={{ span: 24 }}
            xxl={{ span: 24 }}
          >
            <Row type="flex" gutter={[16]}>
              <Col>
                <Button type="primary" onClick={handleSubmit}>
                  Apply
                </Button>
              </Col>
              <Col>
                <Button onClick={() => handleReset(1)}>Clear</Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <DataTable filterValues={{ values }} page={page} setPage={fetchData} />
    </div>
  );
};

export default Dashboard;
